import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "card mb-3" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "row text-center" }
const _hoisted_6 = { class: "card back h-100" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "fw-bold mt-2" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "text-center mt-3" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-6 mb-3"
}
const _hoisted_13 = { class: "card" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "badge bg-secondary" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 2,
  class: "d-flex gap-2"
}
const _hoisted_19 = ["onUpdate:modelValue", "max"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "col-md-6 mb-3" }
const _hoisted_22 = { class: "card" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = {
  key: 0,
  class: "d-flex gap-2"
}
const _hoisted_25 = ["onUpdate:modelValue", "max"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = { class: "badge bg-secondary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "me-2" }, "Changer à :", -1)),
        (_ctx.userData?.stock_ready === 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-success",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveColiStock && _ctx.saveColiStock(...args)))
            }, " Prêt pour la préparation "))
          : _createCommentVNode("", true),
        (_ctx.userData?.stock_ready === 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveColiStock && _ctx.saveColiStock(...args)))
            }, " Nouveau Colis "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Information du destinataire")
      ], -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.receiverInfo, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-md-2 mb-2",
              key: item.label
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_feather_icon, {
                    icon: item.icon,
                    size: "24"
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.label), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(item.value), 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToEdit && _ctx.goToEdit(...args)))
          }, "Modifier")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.userData?.stock_ready === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[7] || (_cache[7] = _createElementVNode("div", { class: "card-header" }, [
                _createElementVNode("h5", { class: "mb-0" }, "Produits En Stock")
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_vue_good_table, {
                  columns: _ctx.columns,
                  rows: _ctx.products
                }, {
                  "table-row": _withCtx(({ row, column }) => [
                    (column.field === 'var_name')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("strong", null, _toDisplayString(row.var_name), 1),
                          _cache[5] || (_cache[5] = _createTextVNode(" : ", -1)),
                          _createElementVNode("span", _hoisted_15, _toDisplayString(row.qty), 1)
                        ], 64))
                      : (column.field === 'product_pic')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (row.product_pic)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  src: row.product_pic,
                                  class: "rounded-circle me-15",
                                  style: {"width":"30px","height":"30px","object-fit":"cover"}
                                }, null, 8, _hoisted_16))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: require('@/assets/images/NoImage.png'),
                                  class: "rounded-circle me-15",
                                  style: {"width":"30px","height":"30px","object-fit":"cover"}
                                }, null, 8, _hoisted_17))
                          ], 64))
                        : (column.field === 'action')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: "form-control form-control-sm",
                                "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                                max: row.qty,
                                min: "1",
                                style: {"width":"80px"}
                              }, null, 8, _hoisted_19), [
                                [
                                  _vModelText,
                                  row.value,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _createElementVNode("button", {
                                class: "btn btn-sm btn-primary",
                                onClick: ($event: any) => (_ctx.addQuantity(row))
                              }, _cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "flaticon flaticon-diskette" }, null, -1)
                              ]), 8, _hoisted_20)
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(row[column.field]), 1)
                            ], 64))
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", { class: "mb-0" }, "Liste des produits du colis")
          ], -1)),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_vue_good_table, {
              columns: _ctx.columns2,
              rows: _ctx.userData?.ProdParcels || []
            }, {
              "table-row": _withCtx(({ row, column }) => [
                (
                    column.field === 'action' && _ctx.userData?.stock_ready === 0
                  )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: "form-control form-control-sm",
                        "onUpdate:modelValue": ($event: any) => ((row.value) = $event),
                        max: row.qnty,
                        min: "1",
                        style: {"width":"80px"}
                      }, null, 8, _hoisted_25), [
                        [
                          _vModelText,
                          row.value,
                          void 0,
                          { number: true }
                        ]
                      ]),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-danger",
                        onClick: ($event: any) => (_ctx.removeQuantity(row))
                      }, _cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "flaticon flaticon-delete" }, null, -1)
                      ]), 8, _hoisted_26)
                    ]))
                  : (column.field === 'product_pic')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        (row.product_pic)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: row.product_pic,
                              class: "rounded-circle me-15",
                              style: {"width":"30px","height":"30px","object-fit":"cover"}
                            }, null, 8, _hoisted_27))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: require('@/assets/images/NoImage.png'),
                              class: "rounded-circle me-15",
                              style: {"width":"30px","height":"30px","object-fit":"cover"}
                            }, null, 8, _hoisted_28))
                      ], 64))
                    : (column.field === 'var_name')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("strong", null, _toDisplayString(row.variant_name), 1),
                          _cache[9] || (_cache[9] = _createTextVNode(" : ", -1)),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(row.qnty), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createTextVNode(_toDisplayString(row[column.field]), 1)
                        ], 64))
              ]),
              _: 1
            }, 8, ["columns", "rows"])
          ])
        ])
      ])
    ])
  ]))
}